module.exports = __webpack_public_path__ + "media/images/pic/brodno/brodno_adults-362b6bcd752f9af7469f3fba83efa924.svg";